module.exports = __webpack_public_path__ + "img/d2.26d055ff.png";